import './scss/vitrine.scss'
import { useState } from 'react'
import { ValorProduto } from './components/ValorProduto'
import { Counter } from './components/Counter'
import { getLinkProduto } from '@/utils/getLinkProduto'
import type { MostruarioMiniaturaProps } from '../../types/vitrineApp.props'
import { TitleCtn } from '../../components/TitleCtn'
import { MidiaProdutoVitrine } from '../../components/MidiaProdutoVitrine'
import { FavoriteButton } from '@/components/vitrine/components/Favorite-button'

export function MostruarioMiniatura({
    hostImagem,
    produtos,
    exibeQuantidadeEstoque,
    tituloVitrine,
    vitrineMacro,
    exibeValoresSomenteLogado,
    precoPrincipal,
    formasDePagamentoPaginaProduto,
    condicaoParcelamentoProduto,
    vitrineButtonAddToCart,
    hoverImagensVitrine,
    hoverImagensVitrineMobile,
    utilizaFavoritosVitrine,
    width,
    height,
    className
}: Readonly<MostruarioMiniaturaProps>) {
    const [produtoAtivo, setProdutoAtivo] = useState(produtos[0])

    return (
        <>
            <TitleCtn tituloVitrine={tituloVitrine} />

            <div className="container">
                <div className={`${className} ${vitrineMacro}`}>
                    <div className="product-principal">
                        <div className="produto-ativo">
                            {Object.values(produtos).map((produto) => {
                                const ativo = produto.codigo === produtoAtivo.codigo
                                
                                return (
                                    <div
                                        key={produto.codigo}
                                        className={`product full ${ativo ? "active" : "inactive"}`}
                                        data-produto-codigo={produto.codigo}
                                    >
                                        <div className="img-product">
                                            <a href={getLinkProduto(produto)} title={produto.titulo || produto.nome}>
                                                <MidiaProdutoVitrine
                                                    hostImagem={hostImagem}
                                                    produto={produto}
                                                    width={width}
                                                    height={height}
                                                    hoverImagensVitrine={hoverImagensVitrine}
                                                    hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                                />
                                            </a>

                                            {utilizaFavoritosVitrine && <FavoriteButton produto={produto} />}
                                        </div>

                                        <div className="conteudo-product">
                                            <div className="name-product">
                                                <h3>
                                                    <a href={getLinkProduto(produto)} title={produto.titulo || produto.nome}>
                                                        {produto.titulo || `${produto.nome} ${produto.derivacao_nome || ""}`}
                                                    </a>
                                                </h3>
                                            </div>

                                            <div className="area-comprar">
                                                {exibeValoresSomenteLogado ? (
                                                    <div className="valores-logados-vitrine">
                                                        <span>Faça login para ver os preços</span>

                                                        <a href={`/login?redir=${encodeURIComponent(globalThis.window.location.href)}`} className="btn-comprar-vitrine flex center justify-center">
                                                            Fazer login
                                                        </a>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className="valor-oferta">
                                                            <ValorProduto
                                                                produto={produto}
                                                                precoPrincipal={precoPrincipal}
                                                                formasDePagamentoPaginaProduto={formasDePagamentoPaginaProduto}
                                                                condicaoParcelamentoProduto={condicaoParcelamentoProduto}
                                                            />

                                                            {Boolean(exibeQuantidadeEstoque) && (
                                                                <div className="oferta-restante">
                                                                    <span className="quantidade-desc">Quantidade <span>em oferta</span></span>
                                                                    <span className="quantidade">{produto.qtde_estoque}</span>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {produto.data_fim && <Counter dataFim={produto.data_fim} />}

                                                        <div className="comprar">
                                                            <a href={getLinkProduto(produto)} className="button button-medium button-buy btn-comprar">
                                                                {vitrineButtonAddToCart}
                                                            </a>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>

                        <div className="produto-miniatura">
                            {Object.values(produtos).map((produto) => (
                                <a
                                    key={produto.codigo}
                                    className={`${produto.codigo === produtoAtivo.codigo ? "active" : ""}`}
                                    onClick={() => setProdutoAtivo(produto)}
                                >
                                    <div className="image-wrapper">
                                        <MidiaProdutoVitrine
                                            hostImagem={hostImagem}
                                            produto={produto}
                                            width={width}
                                            height={height}
                                            hoverImagensVitrine={hoverImagensVitrine}
                                            hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                        />
                                    </div>
                                    <div className="conteudo-miniatura">
                                        <div className="melhor-preco">Melhor Preço</div>
                                        <div className="produto-nome">{produto.nome} {produto.derivacao_nome}</div>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

